<script>
import BankImage from "@/components/ipg/elements/BankImage.vue"

export default {
  name: "BankImgAndAccountOwner",
  components: { BankImage },
  props: {
    iban: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div class="d-flex align-center justify-space-between">
    <BankImage :iban-object="iban" />
    <div
      v-if="
        iban.hasOwnProperty('account_owners') && iban.account_owners.length > 0
      "
      class="font_2 bold d-flex flex-column align-start"
    >
      <div class="d-flex align-center">
        <span
          v-for="(owner, index) in iban.account_owners"
          :key="owner.firstName + owner.lastName + index"
          class="d-flex align-center ml-1"
        >
          {{ owner?.firstName }}
          {{ owner?.lastName }}
          <span
            v-if="
              iban.account_owners.length > 1 &&
              index !== iban.account_owners.length - 1
            "
            >،
          </span>
        </span>
      </div>
      <p class="font_2 mb-0">{{ iban.iban }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
